import React from "react";
import { useMediaQuery } from 'react-responsive';
import WebBusinessMain from './Web';
import MobileBusinessMain from './Mobile';

const BusinessMain = () => {
    const isDesktop = useMediaQuery({ minWidth: 768 }); // 目前PC和平板的尺寸没有做区分
    const isMobile = useMediaQuery({ maxWidth: 767 });

    return (
        <div>
            {isDesktop && <WebBusinessMain />}
            {isMobile && <MobileBusinessMain />}
        </div>
    );
};

export default BusinessMain;